@use "~components/Button/tokens.scss" as button-tokens;

.contentLoader {
  height: button-tokens.$button-standard-height;

  // in case the window is smaller than 335px we want to shrink the
  // svg down to fit, but still impose a maximum width
  width: 100%;
  max-width: 335px;
}
